import { List } from "iconoir-react";
import { useTranslation } from "react-i18next";
import {
  AppLayout,
  AppSidebar,
  BundleHeader,
  EmptyState,
  ListCard,
  LoadingPage,
  PageHeader,
} from "shared/components";
import { useCustomLists } from "./useCustomLists";
import { Flex } from "styled-system/jsx";
import { useState } from "react";
import { BuildNewListModal, StartNewListModal } from "./components";
import { EnumListType } from "gql/generated";

export const CustomLists = () => {
  const [isStartNewListModalOpen, setIsStartNewListModalOpen] = useState(false);
  const [newListDetails, setNewListDetails] = useState({ name: "", type: "" });
  const { t } = useTranslation();
  const {
    appViewSections,
    selectedAppItem,
    onAppViewChange,
    lists,
    searchValue,
    onSearchValueChange,
    loading,
    error,
    onFavouriteClick,
    updatingListId,
  } = useCustomLists();

  if (loading) return <LoadingPage />;

  if (error) throw new Error(error.message);

  return (
    <>
      <AppLayout
        sidebar={
          <AppSidebar
            Icon={List}
            headerTitle={t("customLists:HEADER.TITLE")}
            headerDescription={t("customLists:HEADER.DESCRIPTION")}
            primaryButtonCopy={t("customLists:HEADER.CTA_BUTTON_COPY")}
            primaryButtonProps={{
              visual: "accent.blue",
              onClick: () => setIsStartNewListModalOpen((prev) => !prev),
            }}
            viewTitle={t("customLists:HEADER.VIEWS.TITLE")}
            viewSections={appViewSections}
            onViewSelectionChange={onAppViewChange}
          />
        }
        content={
          <>
            <PageHeader
              Icon={selectedAppItem.Icon}
              title={t(`customLists:HEADER.VIEWS.${selectedAppItem.key}.TITLE`)}
              description={t(
                `customLists:HEADER.VIEWS.${selectedAppItem.key}.DESCRIPTION`,
              )}
            />
            <BundleHeader
              searchProps={{
                value: searchValue,
                onValueChange: onSearchValueChange,
              }}
              count={lists.length}
              Icon={selectedAppItem.Icon}
              title={t(`customLists:HEADER.VIEWS.${selectedAppItem.key}.TITLE`)}
            />
            <Flex flexDir="column" gap="150" flexGrow={1} marginTop="400">
              {lists.length < 1 ? (
                <EmptyState text={t("customLists:PAGE.EMPTY")} />
              ) : (
                <>
                  {lists.map((list) => (
                    <ListCard
                      key={list._id}
                      list={list}
                      updatingListId={updatingListId}
                      onFavoriteClick={onFavouriteClick}
                    />
                  ))}
                </>
              )}
            </Flex>
          </>
        }
      />
      <StartNewListModal
        isOpen={isStartNewListModalOpen}
        onClose={() => setIsStartNewListModalOpen(false)}
        onListTypeSelect={(type, name) => {
          setNewListDetails({ name, type });
          setIsStartNewListModalOpen(false);
        }}
      />
      <BuildNewListModal
        isOpen={
          newListDetails.name.length > 0 && newListDetails.type.length > 0
        }
        onClose={() => setNewListDetails({ name: "", type: "" })}
        name={newListDetails.name}
        type={newListDetails.type as EnumListType}
      />
    </>
  );
};
